import styled from 'styled-components';

export const DetailCSS = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;